import BadgeArt from './BadgeArt';

// A badge rendered as a passport stamp. Same ring geometry as
// Landing/ui.js Stamp, but the center holds the badge artwork (BadgeArt)
// instead of the plane, so it needs its own textPath id.
export default function BadgeStamp({
  badge,
  type,
  className = '',
  text = 'TRAVELFEED · ',
}) {
  return (
    <div className={`tw-relative ${className}`} aria-hidden="true">
      <svg viewBox="0 0 120 120" className="tw-h-full tw-w-full">
        <defs>
          <path
            id="tf-badge-stamp-circle"
            d="M60,60 m-40,0 a40,40 0 1,1 80,0 a40,40 0 1,1 -80,0"
          />
        </defs>
        <circle
          cx="60"
          cy="60"
          r="56"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeDasharray="2.5 4"
        />
        <circle
          cx="60"
          cy="60"
          r="48"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <text
          fontSize="9.5"
          letterSpacing="2"
          fill="currentColor"
          fontFamily="ui-monospace, SFMono-Regular, Menlo, monospace"
          fontWeight="600"
        >
          <textPath href="#tf-badge-stamp-circle">{text}</textPath>
        </text>
      </svg>
      <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
        <span className="tw-relative tw-block tw-h-[46%] tw-w-[46%]">
          <BadgeArt badge={badge} type={type} />
        </span>
      </div>
    </div>
  );
}
